<template name="Notice">
  <div class="page-notice">
    <div class="container">
      <Top :isDetailPage="false" :trainingId="routId" :phoneOremailShow="this.phoneNumber" @changeVisitListStatus="inviteListShow = true"></Top>
    </div>
    <main>
      <div class="container">
        <div class="main-content">
          <h1 class="page-title">{{notice.title}}</h1>
          <article v-html="notice.description" class="notice-content"></article>
          <div class="form-action">
            <div class="container">
              <button type="button" class="btn btn-gradient" @click="agreeNotice">{{$t('Agree')}}</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="container">
      <footerExternal :isLoginPage="false"></footerExternal>
    </div>
    <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTipText" @cancel="closeModal"></alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import Vue from 'vue';
import $ from 'jquery';

import Top from '@/views/external/top.vue';
import footerExternal from '@/components/footerExternal.vue';
import footerMenuExternal from '@/components/footerMenuExternal.vue';
import alertModal from '@/components/alertModal.vue';
import Loading from 'vue-loading-overlay';

import { getInvitationOverview, agreeVisitorNotice, getCurrentAccount } from '@/utils/api';
import { checkNested } from '@/utils/utils';

import 'vue-loading-overlay/dist/vue-loading.css';
var options= {
  fullscreenEl:false,
  escKey: false,
  clickToCloseNonZoomable: true,
}
Vue.use(preview,options)
export default {
  name: 'Notice',
  components: {
    Top,
    footerExternal,
    footerMenuExternal,
    Loading,
    alertModal,
    preview
  },
  data() {
    return {
      inviteListShow: false,
      isLoading: false,
      routId: 0,
      phoneNumber: '',
      notice: {},
      modalTip: false,
      modalTipText: '',
      status: false,
    }
  },
  created() {
    const routeID = this.$route.params.id;
    this.routId = routeID;
    this.getNotice(routeID);
    getCurrentAccount().then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        this.phoneNumber = res.data.content.model;
      }
    });
    setTimeout(() => {
      this.$previewRefresh();

      this.setAttr();
      $(".notice-content img").css('width',"100%");
    }, 2000);
  },
  methods: {
    setAttr(status) {
      $('.notice-content img').attr('preview', '1');
    },
    getNotice(id) {
      getInvitationOverview(id).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.notice = res.data.content.model.notice;
        }
      });
    },
    closeModal() {
      if (this.status) {
        this.$router.push({
          path: '/external/detailIndex/' + this.routId + '/0'
        });
      } else {
        this.modalTip = false;
      }
    },
    agreeNotice() {
      const InvitationId = this.routId;
      agreeVisitorNotice(InvitationId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.modalTip = true;
          this.modalTipText = res.data.content.model;
          if (res.data.content.status === 1) {
            this.status = true;
          }
        } else {
          this.modalTip = true;
          this.modalTipText = res.data.message;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.page-notice {
  color: #4a4a4a;
  .detail-header {
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    margin: 0 -500%;
    padding: 0 500%;
    z-index: 12;
  }
  .main-content {
    padding: 20px 0;
  }
  article {
    p {
      font-size: 13px;
      line-height: 1.62;
      margin-bottom: 5px;
    }
    img {
      margin-bottom: 10px;
      width: 100%;
    }
  }
}
</style>
<style scoped lang="scss">
@import '../../scss/variables.scss';
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.page-notice {
  color: #4a4a4a;
  .page-title {
    font-size: 17px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
  }
  main {
    height: calc(100vh - 110px);
    overflow: auto;
  }
  .main-content {
    width: 45%;
    min-width: 610px;
    margin: 0 auto;
  }
  .form-action {
    text-align: center;
    margin-top: 20px;
    .btn {
      width: 60%;
      padding: 10px 12px;
      font-size: 15px;
    }
  }
  @include respond-to('sm-max') {
    .page-title {
      margin-top: 14px;
      margin-bottom: 13px;
    }
    .main-content {
      width: 100%;
      padding: 0 15px;
      min-width: inherit;
    }
    .form-action {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 99;
      .container {
        padding: 8px 15px;
      }
      .btn {
        width: 100%;
        padding: 6px 12px;
      }
    }
  }
  @include respond-to('ml') {
    .page-title {
      margin-top: 14px;
      margin-bottom: 13px;
    }
    .main-content {
      width: 100%;
      padding: 0 15px;
      min-width: inherit;
    }
    .form-action {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 99;
      .container {
        padding: 8px 15px;
      }
      .btn {
        width: 100%;
        padding: 6px 12px;
      }
    }
  }
}
</style>
